import * as React from 'react';

function SvgIconCheck(props) {
  return (
    <svg
      width={14}
      height={14}
      fill="rgba(0,0,0,.65)"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.75 3.872v-.75a.125.125 0 00-.125-.125h-6a.125.125 0 00-.125.125v.75c0 .069.056.125.125.125h6a.125.125 0 00.125-.125zM3.625 5.247a.125.125 0 00-.125.125v.75c0 .069.056.125.125.125H6.5a.125.125 0 00.125-.125v-.75a.125.125 0 00-.125-.125H3.625zm2.25 7.063H2.25v-11H11v5.375c0 .068.056.125.125.125H12a.125.125 0 00.125-.125v-6a.5.5 0 00-.5-.5h-10a.5.5 0 00-.5.5v12.25a.5.5 0 00.5.5h4.25A.125.125 0 006 13.31v-.875a.125.125 0 00-.125-.125zm6.964.804l-1.458-1.458a2.75 2.75 0 10-.681.638l1.48 1.48a.122.122 0 00.087.036.126.126 0 00.088-.036l.484-.485a.125.125 0 00.027-.135.124.124 0 00-.027-.04zm-3.652-1.367a1.75 1.75 0 110-3.5 1.75 1.75 0 110 3.5z" />
    </svg>
  );
}

export default SvgIconCheck;
